import { omit } from 'lodash-es'

export enum ETabsActiveKeyType {
  SPU_LIST = 'SPU',
  SKU_LIST = 'SKU',
}
export enum EProductsDetailMode {
  ADD = 'add',
  CHECK = 'check',
  EDIT = 'edit',
  RE_EDIT = 're_Edit',
  TO_TAKE_EFFECT = 'toTakeEffect',
  COPY = 'copy',
  IMAGE_EDITING = 'imageEditing',
}
export const EProductsDetailModeName = {
  add: '新增',
  edit: '编辑',
  check: '查看',
  re_Edit: '重编辑',
  toTakeEffect: '编辑',
  copy: '复制',
  imageEditing: '',
}
// 商品类型（1：图书:2：非图:3：组合4：加工:5：卡券:6：服务:7：虚拟、100.全部）
export enum EProductsType {
  BOOKS = '1',
  NOT_BOOKS = '2',
  MACHINING = '4',
  COMBINATION = '3',
  CARD_COUPONS = '5',
  SERVICE = '6',
  FICTITIOUS = '7',
}
export enum EAddDetailSource {
  CATALOGUE = '1', //编目
  PRE_CATALOGUE = '2', //预编目
  SELF = '3', //自编
}
// 商品状态
export enum EProductStatus {
  NORMAL, //正常
  TO_VOID, //作废
}
export const EProductStatusList = [
  // { value: 100, label: '全部' },
  { value: EProductStatus['TO_VOID'], label: '作废' },
  { value: EProductStatus['NORMAL'], label: '正常' },
]

export const columnsHidden: IPermissionColumns = [
  // {
  //   title: '新品标记',
  //   dataIndex: 'newFlag',
  //   // customRender(render: { text: number }) {
  //   //   // （0：非新品，1：新品）
  //   //   return ['非新品', '新品'][render.text]
  //   // },
  // },
  {
    title: '数据类型',
    dataIndex: 'dataType',
    customRender(render: { text: number }) {
      // 0、采访，1、国图，2、CALIS，3、USMARC
      return ['采访', '国图', 'CALIS', 'USMARC'][render.text]
    },
  },
  {
    title: '是否通用',
    dataIndex: 'isCommon',
  },
  {
    title: '出版社',
    dataIndex: 'edition',
  },
  {
    title: '原版价',
    dataIndex: 'originalPrice',
    customRender(render: { text: number }) {
      return render.text != null ? `${(render.text / 10000).toFixed(4)}` : '-'
    },
    width: 140,
  },
  {
    title: '币种',
    dataIndex: 'currencyCode',
  },
  {
    title: '计量单位',
    dataIndex: 'measurementUnitName',
  },
  {
    title: '重量(g)',
    dataIndex: 'weight',
  },
  {
    title: '长(CM)',
    dataIndex: 'length',
  },
  {
    title: '宽(CM)',
    dataIndex: 'width',
  },
  {
    title: '高(CM)',
    dataIndex: 'height',
  },
  {
    title: '原产地',
    dataIndex: 'originalPlace',
  },
  {
    title: '异形标注',
    dataIndex: 'irregularLabelDetail',
  },
  {
    title: '印刷年月',
    dataIndex: 'printDate',
  },
  {
    title: '出版日期',
    dataIndex: 'publicationDate',
  },
  {
    title: '建立日期',
    dataIndex: 'establishDate',
  },
  {
    title: '首版年月',
    dataIndex: 'firstEditionDate',
  },
  {
    title: '最小包装',
    dataIndex: 'pageCount',
  },
  {
    title: '印张',
    dataIndex: 'printSheet',
  },
  {
    title: '主题词',
    dataIndex: 'subjectTerm',
  },
  {
    title: '丛套书标识',
    dataIndex: 'bundleBookSignDetail',
  },
  {
    title: '正丛套书名',
    dataIndex: 'serialAndSetBooksName',
  },
  {
    title: '副丛套书名',
    dataIndex: 'viceSerialAndSetBooksName',
  },
  {
    title: 'CIP分类号',
    dataIndex: 'classificationNumberOfCip',
  },
  {
    title: 'CIP核字号',
    dataIndex: 'verificationNumberOfCip',
  },
  {
    title: '字数',
    dataIndex: 'wordCount',
  },
  {
    title: '印数',
    dataIndex: 'printCount',
  },
  {
    title: '附件/数量',
    dataIndex: 'attachmentTypeAndCount',
  },
  {
    title: '品种来源',
    dataIndex: 'varietySource',
  },
  {
    title: '套书册数',
    dataIndex: 'numberOfSetBooks',
  },
  {
    title: '著译者',
    dataIndex: 'authorTranslator',
  },
  {
    title: '版权书名',
    dataIndex: 'copyrightBookName',
  },
  {
    title: 'CIP作者',
    dataIndex: 'authorOfCip',
  },
  {
    title: 'CIP出版社',
    dataIndex: 'publicationHouseOfCip',
  },
  {
    title: '关键字',
    dataIndex: 'keywords',
  },
  {
    title: '品名的外文名',
    dataIndex: 'foreignName',
  },
  {
    title: '主要演职人员',
    dataIndex: 'mainCastMembers',
  },
  {
    title: '色彩',
    dataIndex: 'colour',
  },
  {
    title: '区码',
    dataIndex: 'areaCode',
  },
  {
    title: '字幕',
    dataIndex: 'subtitle',
  },
  {
    title: '企业内部码',
    dataIndex: 'companyInternalCode',
  },
  {
    title: '播放时间',
    dataIndex: 'playTime',
  },
  {
    title: '画面比例',
    dataIndex: 'pictureScale',
  },
  {
    title: '主要内容编辑人员',
    dataIndex: 'keyInsiderEditorialStaff',
  },
  // {
  //   title: '有无主图',
  //   dataIndex: 'isMainImage',
  //   customRender(render: { text: number }) {
  //     // 0.无，1.有
  //     return ['无', '有'][render.text]
  //   },
  // },
  // {
  //   title: '审读状态',
  //   dataIndex: 'reviewReadStatus',
  //   customRender(render: { text: number }) {
  //     // 0.未审读，1.已审读
  //     return ['未审读', '已审读'][render.text]
  //   },
  // },
  {
    title: '版权提供者',
    dataIndex: 'copyrightProvider',
  },
  {
    title: '首字母缩写',
    dataIndex: 'acronym',
  },
  {
    title: '引进版原书名/引进版原品名',
    dataIndex: 'originalImportedEdition',
  },
  {
    title: '原著责任者',
    dataIndex: 'originalAuthor',
  },
  {
    title: '著作权合同登记号',
    dataIndex: 'copyrightRegistrationNumber',
  },
  {
    title: '总发行',
    dataIndex: 'totalCirculation',
  },
  {
    title: '书写粗细',
    dataIndex: 'writingThicknessIdsDetail',
  },
  {
    title: '颜色',
    dataIndex: 'colourIdsDetail',
  },
  {
    title: '有无签名',
    dataIndex: 'isSignatureDetail',
  },
  {
    title: '初编地点',
    dataIndex: 'originalEditingLocation',
  },
  {
    title: '形式',
    dataIndex: 'form',
  },
  {
    title: '封面JPG',
    key: 'attributeDiagram',
    dataIndex: 'coverJpg',
  },
  {
    title: '封底(图书)',
    key: 'attributeDiagramMore',
    dataIndex: 'backCoverMainImage',
  },
  {
    title: '型号吊牌图',
    key: 'attributeDiagramMore',
    dataIndex: 'modelDropPicture',
  },
  {
    title: '封面PNG',
    key: 'attributeDiagramMore',
    dataIndex: 'coverPng',
  },
  {
    title: '版权页图',
    key: 'attributeDiagramMore',
    dataIndex: 'copyrightMainImage',
  },
  {
    title: '书脊页',
    key: 'attributeDiagramMore',
    dataIndex: 'spinePage',
  },
  {
    title: '扉页',
    key: 'attributeDiagramMore',
    dataIndex: 'titlePage',
  },
  {
    title: '其他封面',
    key: 'attributeDiagramMore',
    dataIndex: 'otherCover',
  },
  {
    title: '其他封面1',
    key: 'attributeDiagramMore',
    dataIndex: 'otherCoverFirst',
  },
  {
    title: '其他封面2',
    key: 'attributeDiagramMore',
    dataIndex: 'otherCoverSecond',
  },
  {
    title: '其他封面3',
    key: 'attributeDiagramMore',
    dataIndex: 'otherCoverThird',
  },
  {
    title: '内页图1',
    key: 'attributeDiagramMore',
    dataIndex: 'innerPageFirst',
  },
  {
    title: '内页图2',
    key: 'attributeDiagramMore',
    dataIndex: 'innerPageSecond',
  },
  {
    title: '内页图3',
    key: 'attributeDiagramMore',
    dataIndex: 'innerPageThird',
  },
  {
    title: '详情页图',
    key: 'attributeDiagramMore',
    dataIndex: 'detailPage',
  },
  {
    title: '海报',
    key: 'attributeDiagramMore',
    dataIndex: 'poster',
  },
  {
    title: '作者照片',
    key: 'attributeDiagramMore',
    dataIndex: 'authorPhoto',
  },
  {
    title: '资料图片',
    key: 'attributeDiagramMore',
    dataIndex: 'dataImage',
  },
  {
    title: '平铺白底图',
    key: 'attributeDiagramMore',
    dataIndex: 'tiledImage',
  },
  {
    title: '营销图',
    key: 'attributeDiagramMore',
    dataIndex: 'marketingImage',
  },
  {
    title: '人员信息名称',
    dataIndex: 'personnelDetailName',
  },
  {
    title: '奖项信息名称',
    dataIndex: 'awardsName',
  },
  {
    title: '年龄段名称',
    dataIndex: 'ageCodeName',
  },
  {
    title: '书目等级名称',
    dataIndex: 'bookLevelName',
  },
  {
    title: '版地名称',
    dataIndex: 'editionAreasName',
  },
  {
    title: '语种名称',
    dataIndex: 'languageName',
  },
  {
    title: '装帧名称',
    dataIndex: 'bindingName',
  },
  {
    title: '开本名称',
    dataIndex: 'formatName',
  },
  {
    title: '发行范围名称',
    dataIndex: 'issueRangeCodingName',
  },
  {
    title: '适合人群/读者对象名称',
    dataIndex: 'readerTypesName',
  },
  {
    title: '是否实物',
    dataIndex: 'isEntity',
    customRender(render: { text: number }) {
      // （0：否，1：是）
      return ['否', '是'][render.text]
    },
  },
  // {
  //   title: '是否周期订阅',
  //   dataIndex: 'periodicSubscription',
  //   customRender(render: { text: number }) {
  //     // （0：否，1：是）
  //     return ['否', '是'][render.text]
  //   },
  // },
  {
    title: '是否开启实物批次管理',
    dataIndex: 'materialObjectBatchManage',
    customRender(render: { text: number }) {
      // （0：否，1：是，2：不启用）
      return ['否', '是', '不启用'][render.text]
    },
  },
  // {
  //   title: '不可售的临保天数',
  //   dataIndex: 'daysBeforeQualityGuaranteePeriod',
  // },
  // {
  //   title: '实物批次管理方式',
  //   dataIndex: 'materialObjectManageMode',
  //   customRender(render: { text: number }) {
  //     // 1、临保多少天可售，2、单品SN码追溯
  //     return ['临保多少天可售', '单品SN码追溯'][render.text]
  //   },
  // },
  {
    title: '审核状态',
    dataIndex: 'auditStatusName',
    key: 'auditStatusName',
    // customRender(render: { text: number }) {
    //   // （1：待提交、2：待审核、3：已驳回、4：已撤回、5：已通过）
    //   return ['待提交', '待审核', '已驳回', '已撤回', '已通过'][render.text]
    // },
  },
  {
    title: '简编时间',
    dataIndex: 'simpleEditTime',
    width: 160,
  },
  {
    title: '简编人',
    dataIndex: 'simpleEditName',
  },
  {
    title: '初编时间',
    dataIndex: 'initialEditTime',
    width: 160,
  },
  {
    title: '初编人',
    dataIndex: 'initialEditName',
  },
  {
    title: '精编时间',
    dataIndex: 'detailedEditTime',
    width: 160,
  },
  {
    title: '精编人',
    dataIndex: 'detailedEditName',
  },
].map((i) => ({ ...omit(i, 'width'), ellipsis: true, width: i.width || 100, isChecked: false }))

export const SpuColumnsHidden: IPermissionColumns = [
  // {
  //   title: '商品类型',
  //   dataIndex: 'commodityTypeName',
  //   width: 100,
  // },
  // {
  //   title: '品牌',
  //   dataIndex: 'commodityBrandName',
  //   width: 100,
  // },
  // {
  //   title: 'SPU价格',
  //   dataIndex: 'spuPrice',
  //   isChecked: false,
  //   customRender(render: { text: number }) {
  //     return render.text?`￥${(render.text / 100).toFixed(2)}`:'-'
  //   },
  // },
  // {
  //   title: '是否周期订阅',
  //   dataIndex: 'periodicSubscriptionName',
  // },
  {
    title: '是否实物',
    dataIndex: 'isEntityName',
    width: 100,
  },
  {
    title: '型号',
    dataIndex: 'model',
  },
].map((i) => ({ ...omit(i, 'width'), ellipsis: true, width: i.width || 100, isChecked: false }))

export type TCommodityButtonAuth = {
  add?: string // 新建
  catalogueAdd?: string // 编目新建
  readyCatalogueAdd?: string // 预编目新建
  selfCatalogueAdd?: string // 自编新建

  catalogueImport?: string // 编目导入
  readyCatalogueImport?: string // 预编目导入
  selfCatalogueImport?: string // 自编导入
  skuExport?: string // sku导出
  spuExport?: string // spu导出

  uupdate?: string // 编辑
  reUpdate?: string // 重编辑
  see?: string // 查看
  copy?: string // 复制新建
  tag?: string // 打标签
  invalid?: string // 作废
  activation?: string // 激活

  addBasic?: string // 创建 基本信息 批量提交并新建
  addImageTextSingle?: string // 创建 图文信息 提交并新建
  addImageTextMultiple?: string // 创建 图文信息 批量提交并新建
  editBasicSave?: string // 修改 基本信息 批量保存
  editImageTextSaveSingle?: string // 修改 图文信息 保存
  editImageTextSaveMultiple?: string // 修改 图文信息 批量保存
  editBasicSubmit?: string // 修改 基本信息 批量提交 --非图才有
  editImageTextSubmitSingle?: string // 修改 图文信息 提交 --非图才有
  editImageTextSubmitMultiple?: string // 修改 图文信息 批量提交  --非图才有
}
